import type { JobCardData } from "../JobCard";

import { Text } from "../../../../mads";

import { StyleSheet } from "react-native";

/**
 * Sponsored disclaimer label (e.g. "Ad", "Anzeige") shown in the bottom-left
 * corner of the job card for EU sponsored jobs. Renders nothing when the
 * server-provided `sponsoredDisclaimer` is null or empty.
 *
 * The text comes from the backend already localized; we display it verbatim.
 */
export function SponsoredDisclaimer({ job }: { job: JobCardData }) {
  const disclaimer = job.sponsoredDisclaimer;
  if (!disclaimer || disclaimer.length === 0) {
    return null;
  }

  return (
    <Text level={1} variant="secondary" accessibilityRole="text" sx={styles.label}>
      {disclaimer}
    </Text>
  );
}

const styles = StyleSheet.create({
  label: {},
});
